import { LocalizedStrict } from "../../../../modules/localization/components/AppLocalized"
import { CreateOrderDialogType } from "../../createOrder/createOrderTypes"

type ReceiptDialogTitleProps = Readonly<{
    dialogType: CreateOrderDialogType
    orderId?: number
}>

export function ReceiptDialogTitle({ dialogType, orderId }: ReceiptDialogTitleProps): React.ReactNode {
    switch (dialogType) {
        case CreateOrderDialogType.CREDIT_NOTE:
            return (
                <LocalizedStrict id="confirm-order-dialog-title-credit-note-order">
                    <>Create credit note</>
                </LocalizedStrict>
            )

        case CreateOrderDialogType.SUPPLEMENTARY_ORDER:
            return (
                <LocalizedStrict id="confirm-order-dialog-title-supplementary-order">
                    <>Create supplementary order</>
                </LocalizedStrict>
            )

        case CreateOrderDialogType.ORDER:
            if (orderId) {
                return (
                    <LocalizedStrict id="confirm-order-dialog-title-update-order" vars={{ id: String(orderId) }}>
                        <>Update order #{orderId}</>
                    </LocalizedStrict>
                )
            }
            return (
                <LocalizedStrict id="confirm-order-dialog-title">
                    <>Confirm order</>
                </LocalizedStrict>
            )

        default:
            return <></>
    }
}
